export default {
    name: 'Nafn',
    tel: 'Sími',
    save: 'Vista',
    confirm: 'Staðfesta',
    cancel: 'Hætta við',
    delete: 'Eyða',
    complete: 'Lokið',
    loading: 'Hleð...',
    telEmpty: 'Fylltu út símanúmer',
    nameEmpty: 'Fylltu út nafn',
    nameInvalid: 'Rangt nafnaform',
    confirmDelete: 'Ertu viss um að þú viljir eyða?',
    telInvalid: 'Ógilt símanúmer',
    vanCalendar: {
        end: 'Endir',
        start: 'Byrjun',
        title: 'Dagatal',
        startEnd: 'Byrjun/Endir',
        weekdays: ['Sun', 'Mán', 'Þri', 'Mið', 'Fim', 'Fös', 'Lau'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Veldu ekki fleiri en ${maxRange} daga`,
    },
    vanCascader: {
        select: 'Velja',
    },
    vanContactCard: {
        addText: 'Bæta við tengiliðaupplýsingum',
    },
    vanContactList: {
        addText: 'Bæta við nýjum tengilið',
    },
    vanPagination: {
        prev: 'Fyrri',
        next: 'Næsti',
    },
    vanPullRefresh: {
        pulling: 'Drepptu niður til að endurlesa...',
        loosing: 'Slepptu til að endurlesa...',
    },
    vanSubmitBar: {
        label: 'Samtals:',
    },
    vanCoupon: {
        unlimited: 'Ótakmarkað',
        discount: (discount) => `${discount * 10}% afsláttur`,
        condition: (condition) => `Að minnsta kosti ${condition}`,
    },
    vanCouponCell: {
        title: 'Afsláttarmiði',
        tips: 'Engir afsláttarmiðar',
        count: (count) => `Þú átt ${count} afsláttarmið${count !== 1 ? 'a' : ''}`,
    },
    vanCouponList: {
        empty: 'Engir afsláttarmiðar',
        exchange: 'Skipta',
        close: 'Loka',
        enable: 'Í boði',
        disabled: 'Ekki í boði',
        placeholder: 'Afsláttarmiðakóði',
    },
    vanAddressEdit: {
        area: 'Svæði',
        postal: 'Póstnúmer',
        areaEmpty: 'Veldu móttökusvæði',
        addressEmpty: 'Heimilisfang má ekki vera autt',
        postalEmpty: 'Rangt póstnúmer',
        defaultAddress: 'Setja sem sjálfgefið heimilisfang',
        telPlaceholder: 'Sími',
        namePlaceholder: 'Nafn',
        areaPlaceholder: 'Svæði',
    },
    vanAddressEditDetail: {
        label: 'Heimilisfang',
        placeholder: 'Heimilisfang',
    },
    vanAddressList: {
        add: 'Bæta við nýju heimilisfangi',
    },
};